import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="bg-navy py-20 px-6" data-id="element-230">
      <div className="max-w-3xl mx-auto" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="border-l-4 border-amber-600 pl-6 md:pl-8 py-2" data-id="element-232">
          <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-6 font-medium" data-id="element-233">
            Estás intentando almorzar, o quizás en el parque con los chicos, y
            de repente: <strong data-id="element-234">vibración</strong>.
          </p>
          <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-6 font-medium" data-id="element-235">
            Mirás la pantalla y{' '}
            <em data-id="element-236">el nombre que aparece te revuelve el estómago</em>.
          </p>
          <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-6 font-medium" data-id="element-237">
            No hace falta ni que abras el mensaje para saber que se viene un
            reclamo, un insulto encubierto o un planteo de hace cinco años.
          </p>
          <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-8 font-medium" data-id="element-238">
            <strong className="text-white" data-id="element-239">
              En tres segundos, tu paz se terminó.
            </strong>{' '}
            Te quedás rumiando la bronca, texteando defensas que no sirven para
            nada y perdiéndote el momento con tus hijos.
          </p>

          <div className="text-center mt-10" data-id="element-240">
            <p className="text-amber-500 font-bold text-sm uppercase tracking-widest animate-pulse" data-id="element-241">
              👇 Seguí leyendo para entender por qué pasa esto
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}